import { AnyAction } from 'redux';

export const FETCH_CONVERSATIONS = 'FETCH_CONVERSATIONS';
export const CREATE_SEARCH_RESPONSE = 'CREATE_SEARCH_RESPONSE';
export const UPDATE_PROPOSAL_ACTION = 'UPDATE_PROPOSAL_ACTION';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const FETCH_PERSISTED_USER = 'FETCH_PERSISTED_USER';
export const FETCH_SEARCH_PROPOSAL = 'FETCH_SEARCH_PROPOSAL';
export const SELECT_SEARCH_PROPOSAL = 'SELECT_SEARCH_PROPOSAL';
export const FETCH_ALL_SEARCH_PROPOSALS = 'FETCH_ALL_SEARCH_PROPOSALS';
export const FETCH_PROPOSALS_BY_SEARCH_ID = 'FETCH_PROPOSALS_BY_SEARCH_ID';
export const FETCH_ALL_FILTERS = 'FETCH_ALL_FILTERS';
export const CREATE_TALKJS_SESSION = 'CREATE_TALKJS_SESSION';
export const UPDATE_UNREAD_CHATS = 'UPDATE_UNREAD_CHATS';
export const CREATE_PROPOSAL_CONVERSATION = 'CREATE_PROPOSAL_CONVERSATION';
export const SAVE_DATA_REFRESH_INTERVAL = 'SAVE_DATA_REFRESH_INTERVAL';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const FETCH_ORGANIZATION_SIGN_UP = 'FETCH_ORGANIZATION_SIGN_UP';
export const GHOST_USER = 'GHOST_USER';
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const RESET_INITIAL_DATA = 'RESET_INITIAL_DATA';

export type IAction = AnyAction;
